import React from "react";
import SelectInput from "./SelectInput";

const Modal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  categorie,
  selectedCategoria,
  onChangeCategoria,
  corsi,
  selectedCorsi,
  onChangeCorsi,
  secondMessage,
  exStudentiCategoria,
  selectedCategoriaExStudenti,
  onChangeCategoriaExStudenti,
  onBlackListChange,
  note,
  dataOra,
  noteValue,
  onNoteChange,
  dataOraChange,
  lead,
}) => {
  if (!isOpen) return null;

  const modalBackgroundStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 50,
  };

  const modalStyle = {
    backgroundColor: "white",
    padding: "24px",
    borderRadius: "8px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    width: "700px",
    maxWidth: "100%",
    maxHeight: "50vh",
    overflowY: "auto",
    zIndex: 60,
  };

  const buttonStyle = {
    padding: "10px 20px",
    borderRadius: "4px",
    cursor: "pointer",
    fontWeight: "bold",
  };

  const cancelButtonStyle = {
    ...buttonStyle,
    backgroundColor: "#E0E0E0",
    color: "#333",
  };

  const confirmButtonStyle = {
    ...buttonStyle,
    backgroundColor: "#A00008",
    color: "#fff",
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const now = new Date();
  const formattedDate = now.toISOString().slice(0, 16);

  return (
    <div style={modalBackgroundStyle} onClick={handleOverlayClick}>
      <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
        <h2
          style={{
            textAlign: "center",
            fontSize: "1.25rem",
            fontWeight: "bold",
            marginBottom: "16px",
          }}
        >
          {title}
        </h2>
        <p
          style={{
            textAlign: "center",
            marginBottom: "24px",
            marginTop: "10px",
            fontWeight: "bold",
          }}
        >
          {message}
        </p>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: "16px",
          }}
        >
          {categorie && (
            <div
              style={{
                marginBottom: 10,
                display: "flex",
                alignItems: "center",
              }}
            >
              <div>
                <SelectInput
                  value={selectedCategoria}
                  name="Categoria"
                  hidable={false}
                  options={categorie}
                  isMulti={true}
                  onChange={onChangeCategoria}
                />
              </div>

              {corsi && (
                <div style={{ marginLeft: 10 }}>
                  <SelectInput
                    value={selectedCorsi}
                    name="Corsi"
                    hidable={false}
                    options={corsi}
                    isMulti={true}
                    onChange={onChangeCorsi}
                  />
                </div>
              )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                Blacklist <input type="checkbox" onChange={onBlackListChange} />
              </div>
            </div>
          )}

          {secondMessage && (
            <p
              style={{
                textAlign: "center",
                marginBottom: "5px",
                fontWeight: "bold",
              }}
            >
              {secondMessage}
            </p>
          )}

          {exStudentiCategoria && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>
                <SelectInput
                  value={selectedCategoriaExStudenti}
                  name="Categoria"
                  hidable={false}
                  options={exStudentiCategoria}
                  isMulti={true}
                  onChange={onChangeCategoriaExStudenti}
                />
              </div>
            </div>
          )}

          {note && (
            <div style={{ flex: "1" }}>
              <h3>Note Leads</h3>
              <div style={{ marginBottom: "16px" }}>
                <label style={{ display: "block", marginBottom: "8px" }}>
                  Data e Ora
                </label>
                <input
                  type="datetime-local"
                  value={dataOra || formattedDate}
                  onChange={dataOraChange}
                  style={{
                    display: "block",
                    width: "100%",
                    padding: "8px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    marginBottom: "16px",
                  }}
                />
              </div>

              <label style={{ display: "block", marginBottom: "8px" }}>
                Note
              </label>
              <textarea
                value={noteValue}
                onChange={onNoteChange}
                style={{
                  width: "100%",
                  height: "100px",
                  padding: "8px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  overflowWrap: "anywhere",
                }}
              ></textarea>
            </div>
          )}

          {lead &&
            lead.map((l, i) => {
              const tagsByCategory = {};
              l.tags.forEach((tag) => {
                if (!tagsByCategory[tag.category]) {
                  tagsByCategory[tag.category] = [];
                }
                tagsByCategory[tag.category].push(tag.tags);
              });

              return (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    marginBottom: "10px",
                    backgroundColor: "#f9f9f9",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <p style={{ margin: "0", color: "#333" }}>
                    <span
                      style={{ margin: "0", fontWeight: "bold", color: "#333" }}
                    >
                      Nome:
                    </span>{" "}
                    {l.nome} {l.cognome}
                  </p>
                  <p style={{ margin: "0", color: "#555" }}>
                    <span
                      style={{ margin: "0", fontWeight: "bold", color: "#333" }}
                    >
                      Telefono:
                    </span>{" "}
                    {l.telefono}
                  </p>
                  <p style={{ margin: "0", color: "#555" }}>
                    <span
                      style={{ margin: "0", fontWeight: "bold", color: "#333" }}
                    >
                      Email:
                    </span>{" "}
                    {l.mail}
                  </p>

                  {Object.keys(tagsByCategory).map((category, index) => (
                    <div
                      key={index}
                      style={{
                        marginBottom: "10px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: "bold",
                          color: "#333",
                          marginRight: "10px",
                        }}
                      >
                        {category.charAt(0).toUpperCase() +
                          category.slice(1).toLowerCase()}
                        :
                      </span>
                      <div
                        style={{
                          display: "flex",
                          gap: "5px",
                          flexWrap: "wrap",
                        }}
                      >
                        {tagsByCategory[category].flatMap(
                          (tagString, tagIndex) => {
                            const tags = tagString.split(", ");
                            return tags.map((tag, i) => (
                              <span
                                key={`${tagIndex}-${i}`}
                                style={{
                                  display: "inline-block",
                                  backgroundColor: "#e0e0e0",
                                  color: "#333",
                                  padding: "1px 8px",
                                  border: "1px solid #ccc",
                                  fontSize: "12px",
                                  textTransform: "capitalize",
                                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                  borderRadius: "4px",
                                }}
                              >
                                {tag.charAt(0).toUpperCase() +
                                  tag.slice(1).toLowerCase()}
                              </span>
                            ));
                          }
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              );
            })}

          {!lead && (
            <div
              style={{ display: "flex", justifyContent: "center", gap: "10px" }}
            >
              <button style={cancelButtonStyle} onClick={onClose}>
                Annulla
              </button>
              <button style={confirmButtonStyle} onClick={onConfirm}>
                Conferma
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
